import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import {
  OpenTelemetryInterceptorModule,
  OTEL_INSTRUMENTATION_PLUGINS,
  OtelColExporterModule,
  W3CTraceContextPropagatorModule,
} from '@jufab/opentelemetry-angular-interceptor'
import buildValueProviderValue from '@vanguard/otl-angular-wrapper'
import otlAngularConfig from '@vanguard/otl-angular-wrapper'

import { environment } from './../environments/environment'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { AemErrorPageComponent } from './components/errors/aem-error-page/aem-error-page.component'
import { FiltersModule } from './components/filters/filters.module'
import { FundListModule } from './components/fund-list/fund-list.module'
import { GlobalFooterComponent } from './components/global-footer/global-footer.component'
import { GlobalHeaderComponent } from './components/global-header/global-header.component'
import { AbstractFilterProcess } from './services/data-filters/abstract-filter-process'
import { FilterProcessImpl } from './services/data-filters/filter-process-impl'
import { AssetClassModel } from './shared/asset-class-model'
import { FilterModel } from './shared/filter-model'
import { VgConstellationModule } from './shared/modules/vg-constellation/vg-constellation.module'
import { CustomDatePipe } from './shared/pipe/custom-date.pipe'
import { SortPipe } from './shared/pipe/sort.pipe'
import { WaitForConditionPipe } from './shared/pipe/wait-for-condition.pipe'
import { ProductTypeModel } from './shared/product-type-model'

const appPrefix = require('../../package.json').deployment.appPrefix // eslint-disable-line @typescript-eslint/no-var-requires

@NgModule({
  declarations: [
    AppComponent,
    GlobalHeaderComponent,
    GlobalFooterComponent,
    AemErrorPageComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    VgConstellationModule,
    HttpClientModule,
    FundListModule,
    OpenTelemetryInterceptorModule.forRoot(
      otlAngularConfig({
        serviceName: 'FD3-INSTITUTIONAL INVESTORS FUND LIST',
        appPrefix: appPrefix,
        sysLevel: environment.SYS_LEVEL,
      }),
    ),
    OtelColExporterModule,
    W3CTraceContextPropagatorModule,
  ],
  providers: [
    FilterModel,
    ProductTypeModel,
    AssetClassModel,
    {
      provide: OTEL_INSTRUMENTATION_PLUGINS,
      useValue: buildValueProviderValue({
        appPrefix: appPrefix,
        serviceName: 'FD3-INSTITUTIONAL INVESTORS FUND LIST',
        sysLevel: environment.SYS_LEVEL,
      }),
    },
    FiltersModule,
    {
      provide: AbstractFilterProcess,
      useClass: FilterProcessImpl,
    },
    CustomDatePipe,
    SortPipe,
    WaitForConditionPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
